import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaGithub,
} from "react-icons/fa";
import { Link } from "react-scroll";
import askLmsLogo from "../../../assets/images/login/logo.png"
import { useNavigate } from "react-router-dom";
function FooterComponents() {
  const navigate = useNavigate();
  return (
    <footer className="bg-dark py-5 landing-page-text ">
      <Container>
        <Row className="gy-4 gx-5 justify-content-center text-center">
          <Col lg={4} md={6}>
            <div className="mb-4">
              <div className="d-flex align-items-center mb-3">
                {/* <svg
                  width="30"
                  height="30"
                  viewBox="0 0 100 100"
                  className="me-2"
                >
                  <circle cx="50" cy="50" r="40" fill="#007bff" />
                  <path
                    d="M35 40L50 60L65 40"
                    stroke="white"
                    strokeWidth="8"
                    fill="none"
                  />
                </svg>
                <span className="fw-bold fs-4">AskLMS</span> */}

                          <img src={askLmsLogo} alt="logo" />
                
              </div>
              <p className="text-muted">
                The ultimate platform for accessing multiple AI models in one
                place. Simplifying the future of AI interaction.
              </p>
            </div>
            {/* <div className="d-flex gap-3">
              <a href="#" className="text-muted">
                <FaTwitter size={20} />
              </a>
              <a href="#" className="text-muted">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-muted">
                <FaLinkedin size={20} />
              </a>
              <a href="#" className="text-muted">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="text-muted">
                <FaGithub size={20} />
              </a>
            </div> */}
          </Col>
          <Col lg={4} md={6}>
      
            <h5 className="mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-muted text-decoration-none cursor-pointer"
                >
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="models"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-muted text-decoration-none cursor-pointer"
                >
                  AI Models
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="features"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-muted text-decoration-none cursor-pointer"
                >
                  Features
                </Link>
              </li>
              {/* <li className="mb-2">
                <Link
                  to="pricing"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-muted text-decoration-none"
                >
                  Pricing
                </Link>
              </li> */}
              <li>
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-muted text-decoration-none cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </Col>
          {/* <Col lg={3} md={6}>
            <h5 className="mb-4">Resources</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  Documentation
                </a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  API Reference
                </a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  Tutorials
                </a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-muted text-decoration-none">
                  Community
                </a>
              </li>
            </ul>
          </Col> */}
          <Col lg={4} md={6}>
            <h5 className="mb-4">Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2 cursor-pointer"onClick={() => navigate('/terms')}>
              <span className="text-muted text-decoration-none">
                  Terms of Service
              </span>
              </li>
              <li className="mb-2 cursor-pointer"onClick={() => navigate('/privacy')}>
              
              <span className="text-muted text-decoration-none">
                  Privacy Policy
                </span>
              </li>
              {/* <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  Cookie Policy
                </a>
              </li>
              <li className="mb-2">
                <a href="#" className="text-muted text-decoration-none">
                  Data Processing
                </a>
              </li>
              <li>
                <a href="#" className="text-muted text-decoration-none">
                  GDPR Compliance
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
        <hr className="mt-4 mb-3" />
        <div className="text-center text-muted">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} AskLMS. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default FooterComponents;
